<template>
  <div>
    <transition name="route" mode="out-in">
      <PreLoader v-show="allIsLoading" />
    </transition>
    <CaroselloHomePage />
    <AboutUs />
    <previewOurSolutionHomePage />
  </div>
</template>

<script>
import PreLoader from "@/components/Global/PreLoader.vue";
import CaroselloHomePage from "../components/UI/CaroselloHomePage.vue";
import AboutUs from "./AboutUs.vue";
import previewOurSolutionHomePage from "@/components/UI/previewOurSolutionHomePage.vue";
import avoidAnotherClick from "@/mixins/avoidDoubleClick.js";
export default {
  name: "HomePage",
  components: {
    PreLoader,
    CaroselloHomePage,
    AboutUs,
    previewOurSolutionHomePage,
  },
  mixins: [avoidAnotherClick],
  data() {
    return {
      lang: localStorage.getItem("language") ?? "en",
      allIsLoading: true,
    };
  },
  async created() {
    let lang = localStorage.getItem("language");
    this.$router.push({ params: { lang: lang } });
    await this.timeout();
    await this.setMetaTags();
  },
  methods: {
    async timeout() {
      // document.body.style.overflow = "hidden";
      // document.documentElement.style.overflow = "hidden";
      setTimeout(() => {
        // document.body.style.overflow = "";
        // document.documentElement.style.overflow = "";
        this.allIsLoading = false;
      }, 1500);
    },
    async setMetaTags() {
      const metaDescription =
        "The Ear stands as a prominent rising star among slot providers within the ever-expanding realm of online gaming. Dive deeper into our story and offerings to uncover the full extent of our journey!";

      document.title = "The Ear | Home";
      const newMetaTag = document.createElement("meta");
      newMetaTag.name = "description";
      newMetaTag.content = metaDescription;
      document.head.appendChild(newMetaTag);
    },
  },
};
</script>

<style scoped>
.container {
  padding: 160px 20px 20px;
}
</style>
